import { useState, useEffect } from 'react'

export default function LiquidTemplate() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 })

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePos({ x: e.clientX, y: e.clientY })
    }
    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [])

  return (
    <div className="relative min-h-screen -m-10 p-10 bg-[#030303] overflow-hidden text-white selection:bg-primary/30">
      
      {/* 1. Global Spotlight Follower */}
      <div 
        className="pointer-events-none fixed inset-0 z-30 transition-opacity duration-500"
        style={{
          background: `radial-gradient(600px circle at ${mousePos.x}px ${mousePos.y}px, rgba(0, 229, 255, 0.08), transparent 80%)`
        }}
      />

      {/* 2. Grid Background */}
      <div className="absolute inset-0 spotlight-grid opacity-20" />

      {/* 3. Hero Header - Asymmetric */}
      <div className="relative z-10 mt-20 mb-32 max-w-4xl">
         <p className="text-primary font-mono text-[10px] uppercase tracking-[0.4em] mb-6 animate-[fade-in_1s_ease-out]">Next-Gen ERP Backbone</p>
         <h1 className="text-8xl font-bold tracking-tighter leading-[0.9] mb-10 animate-[fade-in-up_0.8s_ease-out]">
           Control <br/> 
           <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-teal-400">Everything.</span>
         </h1>
         <div className="flex gap-10 items-center animate-[fade-in_1.5s_ease-out]">
            <div className="h-px flex-1 bg-white/10" />
            <p className="text-white/40 font-medium text-lg max-w-xs">A architectural approach to corporate data management.</p>
         </div>
      </div>

      {/* 4. The Bento Grid (Asymmetric) */}
      <div className="relative z-10 grid grid-cols-12 gap-6 auto-rows-[200px]">
        
        {/* Dynamic Data Card */}
        <div className="col-span-8 row-span-2 glass-card rounded-[2.5rem] p-12 flex flex-col justify-between group overflow-hidden relative">
          {/* Animated Border Beam */}
          <div className="absolute inset-0 rounded-[2.5rem] border border-primary/20 opacity-0 group-hover:opacity-100 transition-opacity duration-1000" />
          
          <div className="flex justify-between items-start">
             <div className="space-y-1">
                <h3 className="text-3xl font-bold tracking-tight">Active Nodes</h3>
                <p className="text-white/30 font-mono text-[10px] uppercase tracking-widest">Live Sync Protocol 4.6</p>
             </div>
             <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center border border-primary/20 shadow-[0_0_30px_rgba(0,229,255,0.2)]">
                <span className="material-symbols-outlined text-primary animate-pulse">hub</span>
             </div>
          </div>

          <div className="flex items-end gap-1 h-32 mb-4">
             {Array.from({ length: 40 }).map((_, i) => (
               <div 
                 key={i} 
                 className="flex-1 bg-primary/20 rounded-full transition-all duration-500 group-hover:bg-primary/50" 
                 style={{ 
                   height: `${30 + Math.random() * 70}%`,
                   transitionDelay: `${i * 10}ms`
                 }} 
               />
             ))}
          </div>
        </div>

        {/* Action Card */}
        <div className="col-span-4 row-span-3 glass-card rounded-[2.5rem] p-10 flex flex-col justify-between hover:bg-white/[0.05] transition-colors cursor-pointer group">
          <div className="space-y-6">
            <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center group-hover:bg-primary group-hover:text-black transition-all duration-500">
               <span className="material-symbols-outlined">bolt</span>
            </div>
            <h3 className="text-2xl font-bold leading-tight">Instant Deployment Control</h3>
            <p className="text-white/40 text-sm leading-relaxed font-medium">Deploy updates to all school terminals with zero-latency synchronization.</p>
          </div>
          
          <div className="space-y-4">
            <div className="h-px bg-white/10 w-full" />
            <div className="flex justify-between items-center text-[10px] font-black uppercase tracking-widest text-primary">
               <span>Launch Sequence</span>
               <span className="material-symbols-outlined !text-[16px]">arrow_forward</span>
            </div>
          </div>
        </div>

        {/* Stat Box 1 */}
        <div className="col-span-4 row-span-1 glass-card rounded-[2rem] p-8 flex items-center gap-6 hover:scale-[1.02] transition-transform">
           <div className="text-4xl font-bold tracking-tighter text-primary">143</div>
           <div className="text-[10px] font-bold text-white/30 uppercase tracking-[0.2em]">Total <br/> Stations</div>
        </div>

        {/* Stat Box 2 */}
        <div className="col-span-4 row-span-1 glass-card rounded-[2rem] p-8 flex items-center gap-6 hover:scale-[1.02] transition-transform">
           <div className="text-4xl font-bold tracking-tighter text-teal-400">12ms</div>
           <div className="text-[10px] font-bold text-white/30 uppercase tracking-[0.2em]">Avg <br/> Latency</div>
        </div>

      </div>

      {/* 5. Minimal Section Label */}
      <div className="mt-32 relative z-10 flex justify-center">
         <div className="px-6 py-2 rounded-full bg-white/5 border border-white/10 text-[10px] font-black uppercase tracking-[0.4em] text-white/40">
           System_Architecture_v2
         </div>
      </div>

    </div>
  )
}
